import { render, staticRenderFns } from "./CoMyBookings.vue?vue&type=template&id=670355aa&"
import script from "./CoMyBookings.vue?vue&type=script&lang=ts&"
export * from "./CoMyBookings.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports